module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/6@2x_8f1cc57079235fe0783406cf31342372.png";